import type { DeckCalcType, DeckEntryDraft } from 'src/components/star-grid/deckConfig.types';
import { DECK_CALC_TYPES, DeckField } from 'src/components/star-grid/deckConfigConstants';
export const deckEntryType = (entry: Pick<DeckEntryDraft, 'calc_type'>): DeckCalcType => entry.calc_type ?? 'Scenario';
export const isScenarioEntry = (entry: Pick<DeckEntryDraft, 'calc_type'>): boolean => deckEntryType(entry) === 'Scenario';
/** Scenario-only configs use one sequence for the group; column configs use row positions. */
export const usesGroupedScenarioSequence = (entry: DeckEntryDraft): boolean =>
  isScenarioEntry(entry) && entry.column_name == null && entry.time_period == null;
export const deckColumnName = (entry: Pick<DeckEntryDraft, 'column_name' | 'fpa_deck_scenario'>): string =>
  entry.column_name || entry.fpa_deck_scenario;
export const deckFieldVisible = (field: DeckField, entry: DeckEntryDraft): boolean => !field.types || field.types.includes(deckEntryType(entry));
export const deckColumnNames = (entries: readonly DeckEntryDraft[]): string[] =>
  [...new Set(entries.filter((entry) => deckEntryType(entry) !== 'SPACER').map(deckColumnName))].filter(Boolean);
export const deckFieldOptions = (
  field: DeckField,
  entry: DeckEntryDraft,
  entries: readonly DeckEntryDraft[],
  scenarios: readonly string[]
): readonly string[] => {
  if (field.kind === 'type') return DECK_CALC_TYPES;
  if (field.kind === 'column') return [...new Set([...deckColumnNames(entries), ...scenarios])];
  if (field.kind !== 'reference') return [];
  return deckEntryType(entry) === 'Variance'
    ? deckColumnNames(entries).filter((name) => name !== (entry.column_name || entry.fpa_deck_scenario))
    : scenarios;
};
